module.exports = __webpack_public_path__ + "img/CeltCapTechCallOfTheBoar.517c6251.webp";